const DEFAULT_COOKIES_SETTINGS = "performance=1,marketing=1"

const parseCookie = (cookie = DEFAULT_COOKIES_SETTINGS) => ({
  performance: cookie.includes("performance=1"),
  marketing: cookie.includes("marketing=1"),
})

export default parseCookie
